export default __webpack_public_path__ + "static/media/king-shark.31c1d347.png";